import React from 'react';
import NoticeStoreEditor from '../NoticeStoreEditor';
import InfoForm from '../../../../../components/outline/InfoForm';
import InputForm from '../../../../../components/form/InputForm';
import Button from '../../../../../components/Button';
import RadioGroupForm from '../../../../../components/form/RadioGroupForm';
import CheckBoxGroupForm from '../../../../../components/form/CheckBoxGroupForm';
import FileUploadForm from '../../../../../components/form/FileUploadForm';
import BaseForm from '../../../../../components/form/BaseForm';
import { REX_URL } from '../../../../../lib/rex';
import {
  NOTICE_STORE_TYPE_SELECT_LIST,
  NOTICE_STORE_STATUS_SELECT_LIST,
  NOTICE_STORE_HOME_EXPOSURE_STATUS_SELECT_LIST,
} from '../../../../../constants/service/app/noticeStoreConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import './NoticeStoreSave.scss';

const NoticeStoreSave = (props) => {
  const {
    form,
    isEdit,
    pageName,
    noticeStoreInfo,
    onSubmit,
    insertImageCallback,
    onChangeAttachment,
    setData,
    noticeStoreLabelList,
  } = props;

  return (
    <InfoForm className="notice-store-save">
      <div className="title">
        <Button isRadius color="primary" text={pageName} onClick={() => onSubmit()} />
      </div>

      {/*구분*/}
      <RadioGroupForm
        label="링크 종류"
        form={form}
        initialValue={noticeStoreInfo.type}
        onChange={(value) => setData({ path: ['noticeStore', 'noticeStoreInfo', 'type'], value })}
        list={NOTICE_STORE_TYPE_SELECT_LIST}
        name="type"
      />

      {/*제목*/}
      <InputForm
        form={form}
        label="제목"
        rules={[formRequiredRules(true, '제목을 입력해주세요.')]}
        initialValue={noticeStoreInfo.title}
        maxLength={100}
        onChange={(value) => setData({ path: ['noticeStore', 'noticeStoreInfo', 'title'], value })}
        name="title"
      />

      {/*라벨*/}
      <CheckBoxGroupForm
        label="라벨"
        form={form}
        initialValue={noticeStoreInfo.labelList}
        onChange={(value) => setData({ path: ['noticeStore', 'noticeStoreInfo', 'labelList'], value })}
        list={noticeStoreLabelList}
        name="labelList"
      />

      {/*본문*/}
      <BaseForm
        label="본문"
        content={
          <NoticeStoreEditor
            isEdit={isEdit}
            content={noticeStoreInfo.content}
            setData={setData}
            insertImageCallback={insertImageCallback}
          />
        }
      />

      {/*상태*/}
      <RadioGroupForm
        label="상태"
        form={form}
        initialValue={noticeStoreInfo.status}
        onChange={(value) => setData({ path: ['noticeStore', 'noticeStoreInfo', 'status'], value })}
        list={NOTICE_STORE_STATUS_SELECT_LIST}
        name="status"
      />

      {/*홈 노출*/}
      <RadioGroupForm
        label="홈 노출"
        form={form}
        initialValue={noticeStoreInfo.isHomeExposure}
        onChange={(value) => setData({ path: ['noticeStore', 'noticeStoreInfo', 'isHomeExposure'], value })}
        list={NOTICE_STORE_HOME_EXPOSURE_STATUS_SELECT_LIST}
        name="isHomeExposure"
      />

      {/*첨부파일*/}
      <BaseForm
        label="첨부파일"
        content={
          <FileUploadForm
            files={noticeStoreInfo.attachment}
            onChange={onChangeAttachment}
            deleteFile={() => setData({ path: ['noticeStore', 'noticeStoreInfo', 'attachment'], value: [] })}
          />
        }
      />

      {/*URL*/}
      <InputForm
        form={form}
        label="URL"
        rules={[
          {
            pattern: REX_URL,
            message: '올바른 URL 을 입력하시기 바랍니다.',
          },
        ]}
        initialValue={noticeStoreInfo.url ? noticeStoreInfo.url.link : null}
        maxLength={100}
        placeholder="ex) https://www.naver.com"
        onChange={(value) => setData({ path: ['noticeStore', 'noticeStoreInfo', 'url', 'link'], value })}
        name="url"
      />
    </InfoForm>
  );
};

export default NoticeStoreSave;
